import type { ReactNode } from 'react';

type FieldProps = {
  /** id связанного контрола. */
  htmlFor: string;
  label: string;
  hint?: string;
  error?: string;
  children: ReactNode;
};

export function Field({ htmlFor, label, hint, error, children }: FieldProps) {
  return (
    <div className="field">
      <label className="field__label" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {hint !== undefined && error === undefined ? (
        <span className="field__hint">{hint}</span>
      ) : null}
      {error !== undefined ? (
        <span className="field__error" id={`${htmlFor}-error`} role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}
